import { apiGet } from "./client";
import type { DashboardKpis, DashboardSummary, DashboardTimeline } from "@/types/dashboard";

export function getDashboardSummary(eventId: number | string): Promise<DashboardSummary> {
  return apiGet<DashboardSummary>(`/api/dashboard/${eventId}`);
}

export function getDashboardKpis(eventId: number | string): Promise<DashboardKpis> {
  return apiGet<DashboardKpis>(`/api/dashboard/${eventId}/kpis`);
}

export function getDashboardTimeline(eventId: number | string): Promise<DashboardTimeline> {
  return apiGet<DashboardTimeline>(`/api/dashboard/${eventId}/timeline`);
}
